"use strict";
import { TransactionStepType } from "features/transactions/steps/types";
import { parseERC20ApproveCalldata } from "utils/approvals";
import { WRAPPED_NATIVE_CURRENCY } from "constants/topazTokenList";
export function createApprovalTransactionStep(txRequest, amountIn, pair) {
  if (!txRequest?.data || !amountIn) {
    return void 0;
  }
  const type = TransactionStepType.TokenApprovalTransaction;
  const token = amountIn.currency.isNative ? WRAPPED_NATIVE_CURRENCY[amountIn.currency.chainId] : amountIn.currency;
  if (!token) {
    console.warn("No wrapped token found for chain:", amountIn.currency.chainId);
    return void 0;
  }
  const { spender } = parseERC20ApproveCalldata(txRequest.data.toString());
  const amount = amountIn.quotient.toString();
  return { type, txRequest, token, spender, amount, pair };
}
